var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircle6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256 240C234.938 240 216 254.094 209.969 274.281C208.656 278.688 208 283.281 208 288C208 314.469 229.531 336 256 336S304 314.469 304 288S282.469 240 256 240ZM256 16C123.451 16 16 123.451 16 256S123.451 496 256 496S496 388.549 496 256S388.549 16 256 16ZM256 384C203.062 384 160 340.938 160 288C160 246.699 187.549 214.711 200.281 203.594L280.219 133.906C284.781 129.938 290.406 128 296 128C302.688 128 309.344 130.781 314.094 136.219C322.812 146.219 321.75 161.375 311.781 170.094L282.021 196.037C322.268 207.467 352 244.141 352 288C352 340.938 308.938 384 256 384Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle6);
export default __webpack_public_path__ + "static/media/circle-6.84f1f44b87289233893cdbe8931e9fe1.svg";
export { ForwardRef as ReactComponent };